export class SignOutRequest {
  public userId: string = '';
  public accessToken: string = '';

  constructor(userId, accessToken: string) {
    this.userId = userId;
    this.accessToken = accessToken;
  }
}
